import { constant, Decoder, either, object, string } from "decoders";

export type JsendResponse<S, F> = JsendSuccess<S> | JsendFail<F>;

export interface JsendSuccess<T> {
  status: "success";
  message: string;
  data: T;
}

export function jsendSuccessFactory<T>(data: T, message = ""): JsendSuccess<T> {
  return {
    status: "success",
    message,
    data,
  };
}

export function jsendSuccessDecoder<S>(dataDecoder: Decoder<S>) {
  return object({ status: constant("success"), data: dataDecoder, message: string });
}

export interface JsendFail<T> {
  status: "fail";
  data: T;
}

export function jsendFailFactory<T>(data: T): JsendFail<T> {
  return {
    status: "fail",
    data,
  };
}

export function jsendFailDecoder<S>(dataDecoder: Decoder<S>) {
  return object({ status: constant("fail"), data: dataDecoder });
}

export function jsendResponseDecoder<S, F>(successDataDecoder: Decoder<S>, failDataDecoder: Decoder<F>) {
  return either(jsendSuccessDecoder(successDataDecoder), jsendFailDecoder(failDataDecoder)) as unknown as Decoder<
    JsendResponse<S, F>
  >;
}
